import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Phone3Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <g clipPath="url(#clip0_284_521)">
        <path
          d="M9.44604 22.5373C13.9665 27.0319 19.4568 30.5 23.946 30.5C25.9638 30.5 27.7313 29.8001 29.1548 28.2448C29.9837 27.3273 30.5 26.2542 30.5 25.1967C30.5 24.419 30.2027 23.6725 29.4676 23.1438L24.6656 19.7535C23.946 19.2558 23.3204 19.007 22.7573 19.007C22.0533 19.007 21.4121 19.4113 20.6925 20.1111L19.582 21.1999C19.4099 21.3709 19.1909 21.4487 18.9876 21.4487C18.753 21.4487 18.5183 21.3553 18.3619 21.2775C17.392 20.7643 15.7341 19.3491 14.1855 17.825C12.6526 16.3008 11.2292 14.6524 10.7287 13.6882C10.6505 13.5171 10.5566 13.2994 10.5566 13.0661C10.5566 12.8639 10.6192 12.6617 10.7912 12.4907L11.9018 11.3554C12.5901 10.64 13.0124 10.0179 13.0124 9.30247C13.0124 8.74261 12.7621 8.13608 12.2303 7.40512L8.8673 2.69284C8.33547 1.94634 7.55339 1.61975 6.70872 1.61975C5.67637 1.61975 4.61272 2.08631 3.68985 2.97278C2.1726 4.41912 1.5 6.20761 1.5 8.18273C1.5 12.6462 4.92557 18.0583 9.44604 22.5373Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_284_521">
          <rect width="29" height="30" fill="currentColor" transform="translate(1.5 0.5)" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
}
